import { render, staticRenderFns } from "./actor-experience.vue?vue&type=template&id=7bceab1c&scoped=true&"
import script from "./actor-experience.vue?vue&type=script&lang=ts&"
export * from "./actor-experience.vue?vue&type=script&lang=ts&"
import style0 from "./actor-experience.vue?vue&type=style&index=0&id=7bceab1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bceab1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VTextField})
